import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { ICanlyniadChwilio } from '../../modelau/canlyniad-chwilio';
import { LazyLoadEvent } from 'primeng/api';
import { IIaithTeitl } from '../../modelau/iaith/iaith-teitl';
import { ApiAnonymousService } from '../api/api-anonymous.service';
import { HelpiwrService } from '../system/helpiwr.service';
import { map } from 'rxjs/operators';
import { IKeyValuePair } from '../../modelau/key-value';

@Injectable()
export class IaithApiService {

  constructor(private apiService: ApiService, private apiAnonymousService: ApiAnonymousService, private helpiwrService: HelpiwrService) { }

  get(rhifIaith: number): Observable<any> {
    return this.apiService.get(`/iaith/${rhifIaith}`);
  }

  getAnhysbys(rhifIaith: number): Observable<any> {
    return this.apiAnonymousService.get(`/iaith/anhysbys/${rhifIaith}`);
  }

  diofyn(): Observable<any> {
    return this.apiService.get(`/iaith/diofyn`);
  }

  nolTeitlIaithDrwyId(id: number): Observable<IIaithTeitl> {
    return this.apiService.get(
      `/iaith/noliaithteitl/${id}`
    );
  }

  diweddaruTeitlIaith(iaith: IIaithTeitl): Observable<IIaithTeitl> {
    if (iaith.id) {
      return this.apiService.put(
        `/iaith/${iaith.id}`, iaith
      );
    } else {
      return this.apiService.post(
        `/iaith`, iaith
      );
    }
  }

  nolTeitlauIaith(): Observable<any> {
    return this.apiService.get(`/iaith/iaithteitl`);
  }

  chwilio(event: LazyLoadEvent): Observable<ICanlyniadChwilio> {
    return this.apiService.post('/iaith/chwilio', event);
  }

  nolIeithoeddSystem(): Observable<ICanlyniadChwilio> {
    return this.apiService.get('/iaith/ieithoeddsystem');
  }

  nolIaithSystemFelKeyValue(): Observable<IKeyValuePair[]> {
    return this.nolIeithoeddSystem()
      .pipe(map(data => this.helpiwrService.felKeyValue(data.eitemau, 'enw')));
  }

  dileu(iaith: IIaithTeitl | number): Observable<IIaithTeitl> {
    const id = typeof iaith === 'number' ? iaith : iaith.id;
    return this.apiService.delete(`/iaith/${id}`);
  }
}
